import React from 'react';

import { NavItem } from './environments';

/**
 * Sidebar items for the educator portal, taken from the redesign prototype.
 *
 * Generated shape rather than hand-drawn: the icons are the prototype's own
 * paths, so the sidebar is pixel-identical to what the CEO reviewed. Editing
 * these by eye is how a port drifts from the thing it is porting.
 *
 * Source: docs/redesign/IQMaxx/3_Teacher_Profesor.html
 */

export const TEACHER_NAV: NavItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    to: '/teacher/dashboard',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    ),
  },
  {
    key: 'courses',
    label: 'My courses',
    to: '/teacher/courses',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>
    ),
  },
  {
    key: 'detail',
    label: 'Course detail',
    to: '/teacher/courses',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
      </svg>
    ),
  },
  {
    key: 'students',
    label: 'Students',
    to: '/teacher/students',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
      </svg>
    ),
  },
  {
    key: 'messages',
    label: 'Messages',
    to: '/teacher/messages',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    key: 'schedule',
    label: 'Schedule',
    to: '/teacher/calendar',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    key: 'live',
    label: 'Live session',
    to: '/teacher/live',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <polygon points="23 7 16 12 23 17 23 7" />
        <rect x="1" y="5" width="15" height="14" rx="2" />
      </svg>
    ),
  },
  {
    key: 'stats',
    label: 'Statistics',
    to: '/teacher/stats',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
  },
  {
    key: 'revenue',
    label: 'Revenue',
    to: '/teacher/earnings',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <rect x="2" y="6" width="20" height="14" rx="2" />
        <path d="M2 10h20" />
      </svg>
    ),
  },
  {
    key: 'reviews',
    label: 'Reviews',
    to: '/teacher/reviews',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <path d="M12 2l3 6.5 7 1-5 5 1.2 7L12 18l-6.2 3.5L7 14.5l-5-5 7-1z" />
      </svg>
    ),
  },
  {
    key: 'settlement',
    label: 'Settlement',
    to: '/teacher/settlement',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v10M9.5 9.5h5M9.5 14.5h5" />
      </svg>
    ),
  },
  {
    // ADM-03-FR-06 — not in the prototype: requests the integrity team sends.
    key: 'evidence',
    label: 'Evidencia pendiente',
    to: '/teacher/evidence-requests',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <path d="M9 11l3 3 8-8" />
        <path d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9" />
      </svg>
    ),
  },
  {
    key: 'resched',
    label: 'Sessions',
    to: '/teacher/sessions',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <path d="M3 12a9 9 0 1 0 3-6.7" />
        <path d="M3 3v5h5" />
      </svg>
    ),
  },
  {
    key: 'resources',
    label: 'Help centre',
    to: '/help',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
  },
];
